
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.99 24.016a5.258 5.258 0 01-3.916-1.748 5.23 5.23 0 01.163-7.175V3.746a3.754 3.754 0 013.75-3.75 3.754 3.754 0 013.75 3.75v11.348a5.215 5.215 0 011.492 3.966 5.217 5.217 0 01-1.742 3.621 5.232 5.232 0 01-3.497 1.335zm-.002-22.52a2.252 2.252 0 00-2.25 2.25v11.668a.75.75 0 01-.25.559 3.753 3.753 0 00-.295 5.295 3.755 3.755 0 005.295.295 3.724 3.724 0 001.244-2.586 3.725 3.725 0 00-1.244-3.004.75.75 0 01-.25-.559V3.746c0-1.24-1.009-2.25-2.25-2.25z"}}),_c('path',{attrs:{"d":"M11.988 20.996a2.252 2.252 0 01-2.25-2.25c0-.96.615-1.808 1.5-2.121V5.246a.75.75 0 011.5 0v11.379a2.26 2.26 0 011.5 2.121 2.252 2.252 0 01-2.25 2.25zm0-3a.75.75 0 100 1.5.75.75 0 000-1.5z"}})])
          )
        }
      }
    